import { Scene } from 'phaser';

export class Boot extends Scene {
  constructor() {
    super('Boot');
  }

  preload() {
    console.error('[MUS-145-DBG] Boot preload()');
    //  The Boot Scene is typically used to load in any assets you require for your Preloader, such as a game logo or background.
    //  The smaller the file size of the assets, the better, as the Boot Scene itself has no preloader.

    this.load.image('background', 'assets/bg.png');
  }

  create() {
    console.error('[MUS-145-DBG] Boot create() — starting Preloader');
    this.scene.start('Preloader');
  }
}
